import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

function RosaAC() {
  const [driveLink, setDriveLink] = useState("");
  const [status, setStatus] = useState("");
  const navigate = useNavigate();

  const userEmail = sessionStorage.getItem("userEmail");

  // --------------------------------------------------
  // CHECK BASIC SIGN-IN
  // --------------------------------------------------
  useEffect(() => {
    if (!userEmail) navigate("/signin");
  }, [navigate, userEmail]);

  // --------------------------------------------------
  // AUTO OAUTH BOOTSTRAP (CRITICAL FIX)
  // --------------------------------------------------
  useEffect(() => {
    const checkOAuth = async () => {
      try {
        const res = await fetch("https://www.d-rosa.ai/oauth-status", {
          credentials: "include",
        });

        if (res.status === 401) {
          // Force OAuth login in SAME SESSION
          window.location.href = "https://www.d-rosa.ai/oauth-login";
        }
      } catch (err) {
        console.error("OAuth check failed", err);
      }
    };

    checkOAuth();
  }, []);

  // --------------------------------------------------
  // CREATE JOURNAL
  // --------------------------------------------------
  useEffect(() => {
    if (!driveLink) return;

    const createJournal = async () => {
      setStatus("Creating Accounts folder and Journal...");

      try {
        const res = await fetch("https://www.d-rosa.ai/create-journal", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({ driveLink }),
        });

        const data = await res.json();

        if (res.status === 401) {
          window.location.href = "https://www.d-rosa.ai/oauth-login";
          return;
        }

        setStatus(
          data.success
            ? "Journal created successfully!"
            : data.message
        );
      } catch (err) {
        setStatus(err.message);
      }
    };

    createJournal();
  }, [driveLink]);

  if (!userEmail) return null;

  return (
    <div style={{ padding: 20 }}>
      <h2 style={{ color: "blue" }}>RosaAC Screen</h2>

      <p style={{ color: "#E11584", fontSize: 18 }}>
        Signed in as: {userEmail}
      </p>

      <input
        type="text"
        placeholder="Paste Google Drive folder link"
        value={driveLink}
        onChange={(e) => setDriveLink(e.target.value)}
        style={{ width: 450, padding: 10 }}
      />

      {status && <p style={{ marginTop: 20 }}>{status}</p>}
    </div>
  );
}

export default RosaAC;
